import { useQuery } from "@tanstack/react-query";
import { privateAxios } from "../axios";

const getBinders = async () => {
	const { data } = await privateAxios.get("/binders");
	return data;
};

export const useGetBinders = () => {
	return useQuery({
		queryKey: ["binders"],
		queryFn: async () => getBinders(),
		retry: false,
	});
};

const getBinder = async (id: string) => {
	const { data } = await privateAxios.get(`/binders/${id}`);
	return data;
};

export const useGetBinder = (id: string) => {
	return useQuery({
		queryKey: ["binder", id],
		queryFn: async () => getBinder(id),
		retry: false,
	});
};
